import React, {Component} from 'react';
import {Carousel} from 'react-bootstrap';
import {IReducerState} from '../../states/renditionStates';
import {connect} from 'react-redux';
import * as asyncStateAction from '../../actions/asyncStateAction';
import servicesConfig from '../../services/servicesConfig';
import '../../../style/features/carousel.scss';
import {RSCH_HTML_TRACKING_CONFIG} from '../../readership/trackingConfig';
import commonStore from '../../store/commonStore.js';
import _ from 'lodash';
import $ from 'jquery';
import { enterKeyPressed } from '../../utils/general/enterKey';

interface ICarouselEventsOldBrandingProps {
    loadEventsSource: (payloadData: any) => {};
    eventsSource: any;
    docHeaderJsonData: any;
}

export class CarouselEventsOldBranding extends Component<ICarouselEventsOldBrandingProps, any> {

    public payload: any;
    public contentRenderFlag = false;

    constructor(props: ICarouselEventsOldBrandingProps) {
        super(props);
        this.payload = {
            ticker: props.docHeaderJsonData.metadata.ticker
        };
        if (!this.isEntitled()) {
            return;
        }
        if (props.docHeaderJsonData.issuerPage.tags
            && props.docHeaderJsonData.issuerPage.tags.tagsByMetadata) {
            this.payload.sector = props.docHeaderJsonData.issuerPage.tags.tagsByMetadata.SECTOR.join();
            this.payload.region = props.docHeaderJsonData.issuerPage.tags.tagsByMetadata.REGION.join();
        }
        props.loadEventsSource(this.payload);
    }

    public isEntitled = () => {
        const initialData = commonStore.getState().asyncStateReducer.initialData;
        return initialData.isEntitled('EVENTS');
    };

    public openEvents = () => {
        RSCH_HTML_TRACKING_CONFIG.trackUpcomingEventsClick();
        return true;
    };

    public openEventsMoreInfo = (eventId: string, link: string) => {
        RSCH_HTML_TRACKING_CONFIG.trackUpcomingEventsMoreInfoClick(eventId);
        return window.open(link, '_blank');
    };

    public componentDidUpdate() {
        if (this.contentRenderFlag) {
            setTimeout(() => {
                this.setAdaAttributes();
            }, 500);
        }
    }

    public setAdaAttributes() {
        const carouselPrev = $('#carouselEventId a.carousel-control-prev');
        const carouselNext = $('#carouselEventId a.carousel-control-next');
        carouselPrev.removeAttr('role href');
        carouselNext.removeAttr('role href');

        $('#uncoming-events ol.carousel-indicators li').each((index, el) => {
            const titleText = $('#uncoming-events .carousel-inner>div').eq(index).find('.event-title').text();
            !$(el).find('span').length &&
                $(el).append('<span tabIndex="0" role="button" aria-label="' + titleText + '"}></span>')
                    .find('span').keypress((e: any) => {
                        const code = e.keyCode || e.which;
                        if (code === 13 || code === 32) {
                            $(el).click();
                        }
                    });
        });
    }

    public handleSelect() {
        $('#uncoming-events .carousel-item.carousel-item').attr('aria-selected', 'false');
        $('#uncoming-events .carousel-item.active.carousel-item').attr('aria-selected', 'true');
    }

    public renderCarouselEvents(eventsSource: any) {
        // scope.bg = HTML_RENDITION.documentsPath_version + 'img/Events-banner-bg.png?ts=' + scope.$root.timestamp;
        /*name of <a>  for tracking event id*/
        if (eventsSource && _.isArray(eventsSource) && eventsSource.length > 0) {
            const template: Array<any> = [];
            eventsSource.forEach((event: any, idx: number) => {
                const eventTitle = event.eventTitle;
                const eventDate = event.startDate + ' - ' + event.endDate;
                const eventLink = event.registrationLink;
                let moreInfoFlag = '';
                const temp: Array<any> = [];
                temp.push(<span className='img-div' style={{position: 'relative', border: 'none'}}
                                key={idx + 'img-div'} role="option" aria-label={eventTitle}>
                    <div className='event-img icon-sprite' role="img" aria-label={eventTitle}></div>
                </span>);
                if (eventLink) {
                    temp.push(
                        <a aria-label='Event more info' tabIndex={0} key={idx + 'events-more-info'} id='events-more-info'
                           onClick={() => this.openEventsMoreInfo(event.eventId, eventLink)} role="link"
                           onKeyPress={(e) => enterKeyPressed(e, this.openEventsMoreInfo.bind(this, event.eventId, eventLink))}>
                            <span className={'more-info'}></span>
                        </a>);
                    moreInfoFlag = 'more-info-flag';
                } else {
                    temp.push(<div aria-label='Contact your Sales Representative to request a meeting' role="text" key={idx + 'event-no-link-info'} className='event-no-link-info'>Contact your Sales
                        Representative to request a meeting</div>);
                }

                if (eventTitle && eventTitle.length > 45) {
                    const shortTitle = eventTitle.substr(0, 45) + "...";
                    temp.push(<div aria-label={shortTitle} role="text" key={idx + 'EventTitle'} className={'event-title ' + moreInfoFlag}
                                   title={eventTitle}>{shortTitle}</div>);
                } else {
                    temp.push(<div aria-label={eventTitle} role="text" key={idx + '!EventTitle'} className={'event-title ' + moreInfoFlag}
                                   title={eventTitle}>{eventTitle}</div>);
                }

                temp.push(<div role="text" aria-label={'Event Date: ' + eventDate} key={idx + 'event-date'} className='event-date'>{eventDate}</div>);

                template.push(<Carousel.Item aria-selected={idx === 0 ? true : false} key={idx + 'Carousel.Item'}>{temp}</Carousel.Item>);
            });

            const directionButtons = (direction: any) => {
                const className = 'carousel-control-' + (direction == 'previous' ? 'prev' : direction) + '-icon';
                return (
                    <span aria-hidden={(eventsSource.length > 1) ? 'false' : 'true'}
                          onKeyPress={(e) => enterKeyPressed.bind(this, this.pressButton(e))}
                          role="button" tabIndex={0}
                          aria-label={direction + ' icon'}
                          className={className}
                    ></span>
                );
            };

            return <Carousel role="listbox"
                controls={(eventsSource.length > 1)}
                indicators={(eventsSource.length > 1)}
                aria-label="event slider"
                keyboard={true}
                id="carouselEventId"
                nextIcon={directionButtons("next")}
                prevIcon={directionButtons("previous")}
                onSelect={() => this.handleSelect()}
            >{template}
            </Carousel>;
        }
    }

    public render() {
        if (!this.isEntitled()) {
            return null;
        }
        const {eventsSource} = this.props;
        this.contentRenderFlag = true;

        return (
            <div aria-label='carousel events' role='region' style={{display: (eventsSource && eventsSource.length > 0) ? 'block' : 'none'}} id='uncoming-events'
                 className='infiniteCarousel' onClick={() => this.openEvents()} onKeyPress={(e) => enterKeyPressed(e, this.openEvents.bind(this))}>
                <div className='wrapper'>{this.renderCarouselEvents(eventsSource)}</div>
            </div>
        );
    }

    private pressButton(e: any) {
        $(e.currentTarget).click();
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        eventsSource: state.asyncStateReducer.eventsSource,
        docHeaderJsonData: state.asyncStateReducer.docHeaderJsonData
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        loadEventsSource: (payloadData: any) => dispatch(asyncStateAction.fetchEventsData(Object.assign(servicesConfig.GET_EVENTS, {'url_parameter': ['rendition_doc_id=' + window.HTML_RENDITION.doc_id]}), payloadData))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CarouselEventsOldBranding);